var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("base-snackbar", {
        attrs: { errors: _vm.projectCodeIndexErrors },
        on: {
          "update:errors": function($event) {
            _vm.projectCodeIndexErrors = $event
          }
        }
      }),
      _c("v-data-table", {
        attrs: {
          dense: "",
          headers: _vm.headers,
          loading: _vm.projectCodeIndexGetting,
          items: _vm.projectCodeIndexList,
          "items-per-page": _vm.itemsPerPage,
          page: _vm.page,
          "server-items-length": _vm.projectCodeIndexGetCount
        },
        on: {
          "update:itemsPerPage": function($event) {
            _vm.itemsPerPage = $event
          },
          "update:items-per-page": function($event) {
            _vm.itemsPerPage = $event
          },
          "update:page": function($event) {
            _vm.page = $event
          }
        },
        scopedSlots: _vm._u([
          {
            key: "top",
            fn: function() {
              return [
                _c("tr", [
                  _c(
                    "td",
                    { attrs: { colspan: "3" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Search",
                          "append-icon": "mdi-magnify"
                        },
                        model: {
                          value: _vm.search,
                          callback: function($$v) {
                            _vm.search = $$v
                          },
                          expression: "search"
                        }
                      })
                    ],
                    1
                  )
                ])
              ]
            },
            proxy: true
          },
          {
            key: "item",
            fn: function({ item }) {
              return [
                _c("tr", [
                  _c("td", { staticClass: "primary--text" }, [
                    _vm._v(_vm._s(item.project_code))
                  ]),
                  _c("td", [_vm._v(_vm._s(item.description))]),
                  _c(
                    "td",
                    [
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "", color: "info" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function({ on, attrs }) {
                                  return [
                                    _c(
                                      "v-icon",
                                      _vm._g(
                                        _vm._b(
                                          { staticClass: "info--text" },
                                          "v-icon",
                                          attrs,
                                          false
                                        ),
                                        on
                                      ),
                                      [_vm._v("mdi-information-outline")]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [_c("p", [_vm._v(_vm._s(item.notes))])]
                      )
                    ],
                    1
                  )
                ])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }